import { render } from "./environment-editor.vue?vue&type=template&id=306794f7"
import script from "./environment-editor.vue?vue&type=script&lang=ts"
export * from "./environment-editor.vue?vue&type=script&lang=ts"
script.render = render

export default script